import styled, { css } from 'styled-components';

import { SCROLLBAR_WIDTH } from '@web/consts/layout';
import {
  MESSAGE_PADDING,
  MESSAGE_SIDEBAR_WIDTH,
  MESSAGE_SIDEBAR_RIGHT_MARGIN,
  CONVERSATION_RIGHT_PADDING,
} from '@web/conversations/consts/layout';
import { ScrollableContainer } from '@web/components/ScrollableContainer/ScrollableContainer';

export const Wrapper = styled.div`
  height: 100%;
  isolation: isolate;
  position: relative;
  width: 100%;
`;

type ScrollableContainerProps = {
  lockScroll: boolean;
};
export const ScrollbaleContainer = styled(ScrollableContainer)<ScrollableContainerProps>`
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
  overflow: ${({ lockScroll }) => (lockScroll ? 'hidden' : 'auto')};
  padding-right: ${CONVERSATION_RIGHT_PADDING - SCROLLBAR_WIDTH}px;
  width: 100%;

  @supports (not (-webkit-hyphens: none)) {
    justify-content: flex-end;
  }
`;

export const ItemsListWrapper = styled.div`
  min-height: 0;
`;

export const ItemsList = styled.div``;

const padding = `
  ${MESSAGE_PADDING}px
  ${MESSAGE_PADDING + CONVERSATION_RIGHT_PADDING - SCROLLBAR_WIDTH}px
  ${MESSAGE_PADDING}px
  ${MESSAGE_PADDING + MESSAGE_SIDEBAR_WIDTH + MESSAGE_SIDEBAR_RIGHT_MARGIN}px
`;
export const LoaderWrapper = styled.div`
  padding: ${padding};
  text-align: center;
`;

const leftOffset = `${
  (MESSAGE_SIDEBAR_WIDTH + MESSAGE_SIDEBAR_RIGHT_MARGIN - CONVERSATION_RIGHT_PADDING) / 2
}px`;
type ButtonProps = {
  alignToBottom?: boolean;
  isActive: boolean;
};
export const Button = styled.button<ButtonProps>`
  ${({ alignToBottom, isActive, theme }) => css`
    --bgColor: ${theme.colors.modalBgOverlay};
    --bottom: ${alignToBottom ? '-20px' : 'unset'};
    --color: ${theme.colors.white};
    --content: ${alignToBottom ? '"»"' : '"«"'};
    --font: ${theme.fonts.fontFamily};
    --opacity: ${isActive ? '1' : 0};
    --pointer: ${isActive ? 'auto' : 'none'};
    --top: ${alignToBottom ? 'unset' : '10px'};
  `};

  background: var(--bgColor);
  border: 0;
  border-radius: 13px;
  bottom: var(--bottom);
  color: var(--color);
  cursor: pointer;
  font: 700 12px/26px var(--font);
  height: 26px;
  left: calc(50% + ${leftOffset});
  opacity: var(--opacity);
  padding: 0 10px;
  pointer-events: var(--pointer);
  position: absolute;
  text-transform: uppercase;
  top: var(--top);
  transform: translateX(-50%);
  z-index: 10;

  &::before {
    content: var(--content);
    display: inline-block;
    font-size: 24px;
    font-weight: 300;
    margin-right: 5px;
    transform: rotate(90deg);
    vertical-align: bottom;
  }
`;
Button.defaultProps = {
  type: 'button',
};
